import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu", "hiddenField"]
  static values = { open: Boolean }

  connect() {
    this.openValue = false
    // Listen for other dropdowns opening
    this.closeHandler = this.closeFromOtherDropdown.bind(this)
    window.addEventListener("dropdown:open", this.closeHandler)
  }

  disconnect() {
    window.removeEventListener("dropdown:open", this.closeHandler)
  }

  toggle(event) {
    this.openValue = !this.openValue
    event.preventDefault()
  }

  openValueChanged() {
    if (this.openValue) {
      // Notify other dropdowns to close
      window.dispatchEvent(new CustomEvent("dropdown:open", { detail: { source: this.element } }))
      this.menuTarget.classList.remove("hidden")
      this.buttonTarget.setAttribute("aria-expanded", "true")
    } else {
      this.menuTarget.classList.add("hidden")
      this.buttonTarget.setAttribute("aria-expanded", "false")
    }
  }

  closeFromOtherDropdown(event) {
    // Close this dropdown if another dropdown opened
    if (event.detail.source !== this.element) {
      this.openValue = false
    }
  }

  close(event) {
    if (event.type === "keydown" && event.key !== "Escape") {
      return
    }
    this.openValue = false
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.openValue = false
    }
  }

  selectOption(event) {
    const value = event.currentTarget.dataset.value

    // Update the hidden field
    this.hiddenFieldTarget.value = value || ""

    // Close the dropdown
    this.openValue = false

    // Submit the form
    const form = this.element.closest("form")
    if (form) {
      form.requestSubmit()
    }
  }
}
